import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import Loading from 'quasar/src/plugins/Loading.js';import Cookies from 'quasar/src/plugins/Cookies.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
export default (function (_ref) {
  var router = _ref.router,
      store = _ref.store,
      ssrContext = _ref.ssrContext;
  router.beforeEach(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(to, from, next) {
      var cookies, aux;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              Loading.show();
              store.dispatch('route/currentRoute', to.meta.auth);
              cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies;

              if (!((store.state.auth.isAuthenticated || to.meta.auth || to.params.brand === 'netatmo' && to.params.id) && cookies.has('auth_token'))) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return store.dispatch('auth/me');

            case 6:
              if (to.name === 'account') {
                if (store.state.auth.isAuthenticated === false) {
                  next('/');
                } else {
                  next();
                }
              }

              aux = LocalStorage.getItem('loginRoute');

              if (to.name === 'home' && store.state.auth.isAuthenticated == false && aux == false) {
                Loading.hide();
              } else {
                next();
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
  router.afterEach(
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(to) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return store.dispatch('metaTags/currentRoute', to.path);

            case 2:
              if (!process.env.SERVER) {
                setTimeout(function () {
                  window.scrollTo(0, 0);
                }, 1000);
              }

              Loading.hide();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }());
});